module.exports = __webpack_public_path__ + "img/20.5bfd68ad.png";